import TeamCard from './TeamCard'

export default TeamCard
